import React from 'react';
import {Link} from 'react-router';
import Parallax from '../Parallax';
import BottomNavigation from '../BottomNavigation';
import { ROUTE_CONTACT, ROUTE_FRIENDS } from '../../constants'

function Hiring() {

  return (
    <div>

      <Parallax image="hiring" alt="Recrutement" title="Recrutement"/>


      <div className="row content section white">
        <div className="col s12">
          <span className="content-title">Recrutage</span>


          <p className="justify">Tu es <b>musicien(ne)</b>, <b>fanfaron(ne)</b> ou <b>batteur(euse)</b> expérimenté(e) ?<br/>
            Tu aimes la <b>fanfare</b> et les montages photos pourris ?<br/>
            Tu veux jouer des <b>supers morceaux</b> avec nous ?<br/>
            Et bien écoute, ça tombe bien !
          </p>

          <p className="justify">La fanfare <b>Mouv' your Baudet</b> RECRUTE aux pupitres suivants (classement par ordre
            alphabétique d'importance) :
          </p>


          <div className="row">

            <div className="col s12 m3">
              <div className="center promo promo-example">
                <img src="/images/instrument/drum.svg" alt="Batterie" className="instrument"/>
                <p className="promo-caption">Batterie complète</p>
                {/*<div className="light center red-text"><h4>URGENT</h4></div>*/}
              </div>
            </div>

            <div className="col s12 m3">
              <div className="center promo promo-example">
                <img src="/images/instrument/trumpet.svg" alt="Trompette" className="instrument"/>
                <p className="promo-caption">Trompette</p>
              </div>
            </div>

            <div className="col s12 m3">
              <div className="center promo promo-example">
                <img src="/images/instrument/trombone.svg" alt="Trombone" className="instrument"/>
                <p className="promo-caption">Trombone</p>
              </div>
            </div>

            <div className="col s12 m3">
              <div className="center promo promo-example">
                <img src="/images/instrument/tuba.svg" alt="Tuba" className="instrument"/>
                <p className="promo-caption">Tuba</p>
              </div>
            </div>

          </div>


          <p className="justify">
            Nos répétitions ont lieu tous les <b>mercredis soir</b> sur Poitiers, dans la cave de Jean-Pierre RAFFARIN.
          </p>

          <p className="justify">
            Tout ça est merveilleux, tu veux rentrer chez les <b>Mouv' your Baudet</b> ? Il ne te reste plus qu'à nous
            envoyer un mail ou à nous passer un coup de bigo :
          </p>

          <p>
            <Link activeClassName={'active'} to={ROUTE_CONTACT} className="waves-effect waves-light btn orange-button"><i
              className="material-icons left">email</i>Contacter le Président</Link>
          </p>

        </div>
      </div>

      <Parallax image="hiring2" alt="Contact"/>

      <BottomNavigation previousText="Amis" previousLink={ROUTE_FRIENDS} nextText="Contact" nextLink={ROUTE_CONTACT} />

    </div>
  );

}

export default Hiring




/** WEBPACK FOOTER **
 ** ./src/components/Hiring/Hiring.jsx
 **/